module.exports = __webpack_public_path__ + "img/s1_t1_01.ec669cad.jpeg";